import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import Avatar from '$app-web/ui-kit/components/avatar';

import classes from './styles.module.scss';

const AvatarWithBorder = (props) => {
    const { avatarColor, classes: outerClasses, className, label, size, src } = props;

    return (
        <div className={clsx(classes.border, classes[`${size}Border`], className, outerClasses.border)}>
            <div className={clsx(classes.avatar, classes.border, classes[`${size}Avatar`], outerClasses.border)}>
                <Avatar colorValue={avatarColor} label={label} size="fill" src={src} />
            </div>
        </div>
    );
};

AvatarWithBorder.defaultProps = {
    avatarColor: undefined,
    classes: {},
    className: undefined,
    label: undefined,
    size: 'sm',
    src: undefined,
};

AvatarWithBorder.propTypes = {
    avatarColor: PropTypes.string,
    classes: PropTypes.oneOfType([PropTypes.object]),
    className: PropTypes.string,
    label: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg']),
    src: PropTypes.string,
};

export default AvatarWithBorder;
